var PNModule = /** @class */ /*@__PURE__*/ (function () {
    function PNModule() {
    }
    return PNModule;
}());
export { PNModule };
